<template>
  <button
    class="grid place-items-center rounded-md border-2 border-dashed border-stone-400 p-4 hover:border-stone-500 focus:border-stone-500"
  >
    <slot>
      <UIcon name="i-ph-plus-bold" class="h-6 w-6 text-stone-400" />
    </slot>
  </button>
</template>
